export enum ReceiptValidationType {
  Date = 'date',
  Amount = 'amount',
  Phone = 'phone',
  CardLastDigits = 'card_last_digits',
  StopScamDate = 'stop_scam_date',
  StopScamAmount = 'stop_scam_amount',
  StopScamValid = 'stop_scam_valid',
  TechProtectionMatch = 'tech_protection_match',
  TechProtectionEdited = 'tech_protection_edited',
  TechProtectionRiskScore = 'tech_protection_risk_score',
  TechProtectionVerdict = 'tech_protection_verdict',
  ChequeWalesVerdict = 'cheque_wales_verdict',
  ChequeWalesDate = 'cheque_wales_date',
  ChequeWalesAmount = 'cheque_wales_amount',
  ChequeWalesBank = 'cheque_wales_bank',
  ChequeWalesRecipient = 'cheque_wales_recipient',
}
